import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CloudUploadFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.96 13.56C21.96 16.24 19.84 18.26 17.06 18.26H6.56C3.9 18.26 2.04 16.6 2.04 14.26C2.04 12.52 3.2 11.06 4.88 10.7C5.28 7.46 7.98 5.16 11.3 5.16C13.74 5.16 16.06 6.56 17.26 9.1C20.24 9.16 21.96 11.16 21.96 13.56ZM8.16 13.46L9.32 14.6L11.64 12.34L13.96 14.6L15.12 13.46L11.64 10.12L8.16 13.46Z" />
    </SvgIcon>
  );
});
